<template>
  <el-dialog
    title="申请试用"
    width="500px"
    :close-on-click-modal="false"
    :visible.sync="visible"
    class="tryout-modal">
    <el-form
      :model="data"
      ref="form"
      :rules="rules"
      @submit.prevent="beforeSubmit">
      <el-form-item prop="name" size="small" label="联系人">
        <el-input
          placeholder="请输入联系人姓名"
          v-model="data.name"></el-input>
      </el-form-item>
      <el-form-item prop="phone" size="small" label="联系电话">
        <el-input
          placeholder="请输入联系电话"
          v-model="data.phone"></el-input>
      </el-form-item>
      <el-form-item prop="city" size="small" label="所在城市">
        <el-input
          placeholder="请输入所在城市"
          v-model="data.city"></el-input>
      </el-form-item>
      <el-form-item prop="remark" size="small" label="备注">
        <el-input
          type="textarea"
          placeholder="备注"
          v-model="data.remark"
          show-word-limit
          :rows="4"
          :maxlength="200"
          resize="none"></el-input>
      </el-form-item>
      <el-form-item size="small" style="margin-top: 30px; text-align: center;">
        <el-button
          @click="beforeSubmit"
          :loading="loading"
          type="primary"
          style="width: 80px;">提交
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      data: {
        name: '',
        phone: '',
        city: '',
        remark: '',
      },
      rules: {
        name: [
          { required: true, message: '联系人不能为空' },
        ],
        phone: [
          { required: true, message: '联系电话不能为空' },
          { min: 7, message: '联系电话长度太短', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    visible(v) {
      if (!v && this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
  },
  created() {
    this.$root.$on('tryout', this._openTryout = () => {
      this.visible = true;
    });
  },
  beforeDestroy() {
    this.$root.$off('tryout', this._openTryout);
  },
  methods: {
    beforeSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onSubmit();
        }
      });
    },
    async onSubmit() {
      this.loading = true;
      try {
        await this.$http.post('/hostweb/tryout', {
          linkName: this.data.name,
          linkPhone: this.data.phone,
          city: this.data.city,
          memo: this.data.remark,
        });
        this.$alert('申请试用成功', '提示');
        this.$refs.form.resetFields();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
  .tryout-modal {
    .el-form {
      margin: 0 20px;

      .el-input__count {
        height: 12px;
        display: inline-block;
        line-height: 1;
      }
    }
  }
</style>
